export enum SortType {
  ASC = 1, DESC = -1
}
